export enum TabsOrientation {
  horizontal = 'horizontal', // default
  vertical = 'vertical',
}

export enum TabsTextTransform {
  uppercase = 'uppercase', // default
  none = 'none',
}
